module.exports = __webpack_public_path__ + "static/media/contact-student-docent.fb65719f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Contact/03_Studenten/contact-student-docent.jpg
// module id = 715
// module chunks = 0